module.exports = __webpack_public_path__ + "img/5.835379c2.png";